import { Container } from "@mui/material";
import { useSelector } from "react-redux";
import { makeStyles } from "@mui/styles";
import ListingDashboardNavbar from "../bars/listingDashboardNavbar";
import { Toast } from "../overlays/toast";
import { ResponsiveRow } from "../../constants/layout.constants";
import { Suspense } from "react";
import LoadingOverlay from "../overlays/loadingOverlay";

// Using Inline Styling
const useStyles = makeStyles((theme) => ({
  navbar: {
    backgroundColor: "#037171",
    minHeight: "6vmin",
    fontSize: `calc(10px + 2vmin)`,
    color: "white",
  },
  menuButton: {
    color: "white!important",
  },
  subMenu: {
    "& .MuiPaper-root": {
      backgroundColor: "#037171",
      color: "white",
    },
  },
  subMenuLink: {
    color: "white",
    textDecoration: "none",
  },
  secureContainer: {
    minHeight: "92.5vmin",
  },
  unsecureContainer: {
    minHeight: "100vmin",
    width: "100vw",
    margin: "auto",
    padding: 0,
    zIndex: 10,
  },
}));

export default function ListingsLayout(props) {
  const { children } = props;
  const classes = useStyles();
  const message = useSelector(state => state.message);
  const modals = useSelector(state => state.modals);
  const isAnyModalOpen = modals.openModals > 0;

  return (
    <ResponsiveRow
      sx={{
        position: "relative",
        maxHeight: "100vh",

        flexDirection: "column",
        flexWrap: "nowrap",

        justifyContent: "flex-start",
        alignItems: "center",

        overflowX: "hidden",
        overflowY: "hidden",
        padding: "0 !important",
        margin: "0 !important",
        paddingLeft: "0 !important",
        paddingRight: "0 !important",
      }}
    >
      <ListingDashboardNavbar />
      {!isAnyModalOpen && message.display && <Toast />}{" "}
      <Container
        className={classes.secureContainer}
        maxWidth={false}
        sx={{
          "&.MuiContainer-root": {
            height: "90%",
            width: "100%",
            margin: "auto",
            overflowY: "auto",
          },
        }}
        disableGutters={true}
      >
        <Suspense
          fallback={<LoadingOverlay message="Page loading... please wait" />}
        >
          {children}
        </Suspense>
      </Container>
    </ResponsiveRow>
  );
}
